// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oSm0bis2nsEEDhrwDreM {
  display: inline-block;
  position: relative;
  width: 100%;
}

.KaO19IGjxTO5Ni5xJE65 {
  display: inline-block;
  position: absolute;
  height: 32px;
  right: 0px;
  top: 0px;
  z-index: 1;
}
.KaO19IGjxTO5Ni5xJE65 button {
  color: var(--blue-color-70);
}`, "",{"version":3,"sources":["webpack://./src/components/DownloadableSection/DownloadableSection.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AACF;AACE;EACE,2BAAA;AACJ","sourcesContent":[".container {\n  display: inline-block;\n  position: relative;\n  width: 100%;\n}\n\n.button {\n  display: inline-block;\n  position: absolute;\n  height: 32px;\n  right: 0px;\n  top: 0px;\n  z-index: 1;\n\n  button {\n    color: var(--blue-color-70);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `oSm0bis2nsEEDhrwDreM`,
	"button": `KaO19IGjxTO5Ni5xJE65`
};
export default ___CSS_LOADER_EXPORT___;
